import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'pewag',
} as IModuleProps;
